import { makeStyles } from '@material-ui/core/styles'

import { COLORS, FONT_FAMILY, FONT_WEIGHT } from 'styles'

const useStyles = makeStyles({
  toast: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 480,
    maxWidth: 720,
    boxSizing: 'border-box',
    backgroundColor: COLORS.WHITE,
    padding: '14px 16px 14px 0',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
    overflow: 'hidden',
  },
  toastSuccess: {
    borderLeft: `6px solid ${COLORS.SUCCESS}`,
    color: COLORS.SUCCESS,
  },
  toastError: {
    borderLeft: `6px solid ${COLORS.PRIMARY}`,
    color: COLORS.PRIMARY,
  },
  icon: {
    display: 'flex',
    flexShrink: 0,
    marginLeft: 16,
    marginRight: 12,
  },
  body: {
    display: 'flex',
    alignItems: 'baseline',
    flexWrap: 'wrap',
    flex: 1,
    minWidth: 0,
    columnGap: 6,
  },
  title: {
    fontFamily: FONT_FAMILY,
    fontWeight: FONT_WEIGHT.semiBold,
    fontSize: 14,
    lineHeight: 1.4,
  },
  message: {
    fontFamily: FONT_FAMILY,
    fontWeight: FONT_WEIGHT.regular,
    fontSize: 14,
    lineHeight: 1.4,
  },
  closeButton: {
    marginLeft: 12,
    padding: 4,
    color: 'inherit',
  },
})

export { useStyles }
